// Serviços compartilhados pelas telas (desktop, som, barra flutuante) e a navegação.
import { createContext, useContext } from 'react';
import type { OAuthProvider } from '../data/auth';
import type { AutostartBridge } from '../platform/autostart';
import type { DesktopBridge } from '../platform/desktop';
import type { SoundPlayer } from '../platform/sound';
import type { FloatController } from './floatController';

export interface Services {
  desktop: DesktopBridge | null;
  float: Pick<FloatController, 'openFloat' | 'isVisible' | 'subscribe'>;
  sound: SoundPlayer;
  /** abre links externos: navegador do sistema no desktop, a própria aba na web */
  openExternal(url: string): Promise<void>;
  /** iniciar com o computador — só no desktop (AC-129) */
  autostart: AutostartBridge | null;
  /** botões de login social que aparecem (AC-240) */
  oauthProviders: readonly OAuthProvider[];
}

export const ServicesContext = createContext<Services | null>(null);

export function useServices(): Services {
  const s = useContext(ServicesContext);
  if (!s) throw new Error('ServicesContext ausente');
  return s;
}

export type View = 'tasks' | 'focus' | 'settings' | 'subscription';

export interface Nav {
  view: View;
  go(view: View): void;
}

export const NavContext = createContext<Nav>({ view: 'tasks', go: () => {} });

export function useNav(): Nav {
  return useContext(NavContext);
}
